import appConstants from '../../../../../../../../../constants';
import { KEYS } from '../../../../../../../../../l18n/constants';
import computeClassName from '../../../../../../../../../utils/computeClassName';
import { useL18nContext } from '../../../../../../../ContextProvider/L18n';
import { useUserContext } from '../../../../../../../ContextProvider/User';
import { usePartnerSearchContext } from '../../../../../../../ContextProvider/Partner/Search';
import PartnerTile from '../../Tile';
import SavedPartnersSection from './Section';
import handleEventClick from "../../../../../../../../../utils/handleEventClick";

const constants = Object.freeze({
  CLASSNAME_BASE: 'border-t border-cc-gray-05 px-2 2xs:px-0 py-6'
});

export default function SavedPartners({className}) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { getTranslationFor } = useL18nContext();
  const translatedButtonLabelClearComparator = getTranslationFor(KEYS.L18N_KEY_LABEL_CLEAR_COMPARATOR);
  const translatedLabelOther = getTranslationFor(KEYS.L18N_KEY_LABEL_OTHER);
  const translatedLabelNoMatchesFound = getTranslationFor(KEYS.L18N_KEY_LABEL_NO_MATCHES_FOUND);

  const { userSavedPartners } = useUserContext();
  const {
    comparedItemList,
    comparedItemCategory,
    clearComparator,
    selectedPartnerRoleCode,
    derivedSelectedPartnerRoleCode,
    isFilterByNeedFormSelected,
    isSearchByCombinedCriteriaFormSelected,
  } = usePartnerSearchContext();

  const realSelectedPartnerRoleCode =
    isFilterByNeedFormSelected() ?
      selectedPartnerRoleCode :
      isSearchByCombinedCriteriaFormSelected() ?
        derivedSelectedPartnerRoleCode:
        '';

  const integrators = userSavedPartners.filter((savedPartner) => Object.keys(savedPartner.rolesAndLevels).includes(appConstants.VALUE_INTEGRATOR));
  const providers = userSavedPartners.filter((savedPartner) => Object.keys(savedPartner.rolesAndLevels).includes(appConstants.VALUE_PROVIDER));
  const developers = userSavedPartners.filter((savedPartner) => Object.keys(savedPartner.rolesAndLevels).includes(appConstants.VALUE_DEVELOPER));
  const advisors = userSavedPartners.filter((savedPartner) => Object.keys(savedPartner.rolesAndLevels).includes(appConstants.VALUE_ADVISOR));
  const others = userSavedPartners.filter((savedPartner) => !Object.keys(savedPartner.rolesAndLevels).includes(appConstants.VALUE_INTEGRATOR) &&
                                                            !Object.keys(savedPartner.rolesAndLevels).includes(appConstants.VALUE_PROVIDER) &&
                                                            !Object.keys(savedPartner.rolesAndLevels).includes(appConstants.VALUE_DEVELOPER) &&
                                                            !Object.keys(savedPartner.rolesAndLevels).includes(appConstants.VALUE_ADVISOR));
  const clearComparatorClickFn = handleEventClick(clearComparator);

  return (
    <div className={computedClassName}>

      <SavedPartnersSection className="mb-5"
                            sectionTitle={appConstants.LABEL_INTEGRATOR}
                            sectionPartnerRole={appConstants.VALUE_INTEGRATOR}
                            selectedPartnerRoleCode={realSelectedPartnerRoleCode}
                            savedPartners={integrators}
                            isComparatorToBeShown={true}
                            comparedItemList={comparedItemList}
                            comparedItemCategory={comparedItemCategory}
                            clearComparatorText={translatedButtonLabelClearComparator}
                            clearComparatorClickFn={clearComparatorClickFn}
                            noSavedPartnersText={translatedLabelNoMatchesFound}/>

      <SavedPartnersSection className="border-t border-cc-gray-05 pt-4 mb-5"
                            sectionTitle={appConstants.LABEL_PROVIDER}
                            sectionPartnerRole={appConstants.VALUE_PROVIDER}
                            selectedPartnerRoleCode={realSelectedPartnerRoleCode}
                            savedPartners={providers}
                            isComparatorToBeShown={true}
                            comparedItemList={comparedItemList}
                            comparedItemCategory={comparedItemCategory}
                            clearComparatorText={translatedButtonLabelClearComparator}
                            clearComparatorClickFn={clearComparatorClickFn}
                            noSavedPartnersText={translatedLabelNoMatchesFound}/>

      <SavedPartnersSection className="border-t border-cc-gray-05 pt-4 mb-5"
                            sectionTitle={appConstants.LABEL_DEVELOPER}
                            sectionPartnerRole={appConstants.VALUE_DEVELOPER}
                            selectedPartnerRoleCode={realSelectedPartnerRoleCode}
                            savedPartners={developers}
                            isComparatorToBeShown={true}
                            comparedItemList={comparedItemList}
                            comparedItemCategory={comparedItemCategory}
                            clearComparatorText={translatedButtonLabelClearComparator}
                            clearComparatorClickFn={clearComparatorClickFn}
                            noSavedPartnersText={translatedLabelNoMatchesFound}/>

      <SavedPartnersSection className="border-t border-cc-gray-05 pt-4 mb-5"
                            sectionTitle={appConstants.LABEL_ADVISOR}
                            sectionPartnerRole={appConstants.VALUE_ADVISOR}
                            selectedPartnerRoleCode={realSelectedPartnerRoleCode}
                            savedPartners={advisors}
                            isComparatorToBeShown={true}
                            comparedItemList={comparedItemList}
                            comparedItemCategory={comparedItemCategory}
                            clearComparatorText={translatedButtonLabelClearComparator}
                            clearComparatorClickFn={clearComparatorClickFn}
                            noSavedPartnersText={translatedLabelNoMatchesFound}/>

      <SavedPartnersSection className="border-t border-cc-gray-05 pt-4 mb-5"
                            sectionTitle={translatedLabelOther}
                            sectionPartnerRole={null}
                            selectedPartnerRoleCode={'none'}
                            savedPartners={others}
                            isComparatorToBeShown={false}
                            comparedItemList={comparedItemList}
                            comparedItemCategory={comparedItemCategory}
                            clearComparatorText={translatedButtonLabelClearComparator}
                            clearComparatorClickFn={clearComparatorClickFn}
                            noSavedPartnersText={translatedLabelNoMatchesFound}/>
    </div>
  );
}


//<section className="mb-10">
//  <header className="flex flex-row items-center justify-between py-2 mb-4">
//    <h3><span className="font-semibold">{appConstants.LABEL_INTEGRATOR}</span><span className="ml-cc-1char text-cc-accent">({integrators.length})</span></h3>
//  </header>
//  <div className="max-w-full overflow-x-auto 3xs:overflow-visible pb-4">
//    <ul className="list-none flex flex-row space-x-6 3xs:space-x-0 3xs:grid 3xs:grid-cols-2 xs:grid-cols-3 md:grid-cols-4 3xs:gap-6 mb-4">
//      {
//        integrators.map(
//          (savedPartner, index) => {
//            return (
//              <li key={index} className="flex-shrink-0 w-cc-55 3xs:w-auto">
//                <PartnerTile partner={savedPartner}
//                             selectedPartnerRoleCode={appConstants.VALUE_INTEGRATOR}
//                             isComparatorToBeShown={true}/>
//              </li>
//            )
//          }
//        )
//      }
//    </ul>
//    {
//      (integrators.length === 0) &&
//      <p>{translatedLabelNoMatchesFound}</p>
//    }
//    {
//      (!!integrators.length) && (comparedItemCategory === appConstants.VALUE_INTEGRATOR) && (!!comparedItemList.length) &&
//      <p className="mt-4"><a href="/" onClick={clearComparatorClickFn} className="text-cc-link text-cc-body-medium">{translatedButtonLabelClearComparator}</a></p>
//    }
//  </div>
//</section>
//
//      <section className="border-t border-cc-gray-05 pt-4">
//         <header className="flex flex-row items-center justify-between py-2 mb-4">
//           <h3><span className="font-semibold">{appConstants.LABEL_PROVIDER}</span><span className="ml-cc-1char text-cc-accent">({providers.length})</span></h3>
//         </header>
//         <div className="max-w-full overflow-x-auto 3xs:overflow-visible pb-12">
//           <ul className="list-none flex flex-row space-x-6 3xs:space-x-0 3xs:grid 3xs:grid-cols-2 xs:grid-cols-3 md:grid-cols-4 3xs:gap-6 mb-4">
//             {
//               providers.map(
//                 (savedPartner, index) => {
//                   return (
//                     <li key={index} className="flex-shrink-0 w-cc-55 3xs:w-auto">
//                       <PartnerTile partner={savedPartner}
//                                    selectedPartnerRoleCode={appConstants.VALUE_PROVIDER}
//                                    isComparatorToBeShown={true}/>
//                     </li>
//                   )
//                 }
//               )
//             }
//           </ul>
//           {
//             (providers.length === 0) &&
//             <p>{translatedLabelNoMatchesFound}</p>
//           }
//           {
//             (!!providers.length) && (comparedItemCategory === appConstants.VALUE_PROVIDER) && (!!comparedItemList.length) &&
//             <p className="mt-4"><a href="/" onClick={clearComparatorClickFn} className="text-cc-link text-cc-body-medium">{translatedButtonLabelClearComparator}</a></p>
//           }
//         </div>
//       </section>
//       <section className="border-t border-cc-gray-05 pt-4">
//         <header className="flex flex-row items-center justify-between py-2 mb-4">
//           <h3><span className="font-semibold">{appConstants.LABEL_DEVELOPER}</span><span className="ml-cc-1char text-cc-accent">({developers.length})</span></h3>
//         </header>
//         <div className="max-w-full overflow-x-auto 3xs:overflow-visible pb-12">
//           <ul className="list-none flex flex-row space-x-6 3xs:space-x-0 3xs:grid 3xs:grid-cols-2 xs:grid-cols-3 md:grid-cols-4 3xs:gap-6 mb-4">
//             {
//               developers.map(
//                 (savedPartner, index) => {
//                   return (
//                     <li key={index} className="flex-shrink-0 w-cc-55 3xs:w-auto">
//                       <PartnerTile partner={savedPartner}
//                                    selectedPartnerRoleCode={appConstants.VALUE_DEVELOPER}
//                                    isComparatorToBeShown={true}/>
//                     </li>
//                   )
//                 }
//               )
//             }
//           </ul>
//           {
//             (developers.length === 0) &&
//             <p>{translatedLabelNoMatchesFound}</p>
//           }
//           {
//             (!!developers.length) && (comparedItemCategory === appConstants.VALUE_DEVELOPER) && (!!comparedItemList.length) &&
//             <p className="mt-4"><a href="/" onClick={clearComparatorClickFn} className="text-cc-link text-cc-body-medium">{translatedButtonLabelClearComparator}</a></p>
//           }
//         </div>
//       </section>
//
//       <section className="border-t border-cc-gray-05 pt-4">
//         <header className="flex flex-row items-center justify-between py-2 mb-4">
//           <h3><span className="font-semibold">{appConstants.LABEL_ADVISOR}</span><span className="ml-cc-1char text-cc-accent">({advisors.length})</span></h3>
//         </header>
//         <div className="max-w-full overflow-x-auto 3xs:overflow-visible pb-12">
//           <ul className="list-none flex flex-row space-x-6 3xs:space-x-0 3xs:grid 3xs:grid-cols-2 xs:grid-cols-3 md:grid-cols-4 3xs:gap-6 mb-4">
//             {
//               advisors.map(
//                 (savedPartner, index) => {
//                   return (
//                     <li key={index} className="flex-shrink-0 w-cc-55 3xs:w-auto">
//                       <PartnerTile partner={savedPartner}
//                                    selectedPartnerRoleCode={appConstants.VALUE_ADVISOR}
//                                    isComparatorToBeShown={true}/>
//                     </li>
//                   )
//                 }
//               )
//             }
//           </ul>
//           {
//             (advisors.length === 0) &&
//             <p>{translatedLabelNoMatchesFound}</p>
//           }
//           {
//             (!!advisors.length) && (comparedItemCategory === appConstants.VALUE_ADVISOR) && (!!comparedItemList.length) &&
//             <p className="mt-4"><a href="/" onClick={clearComparatorClickFn} className="text-cc-link text-cc-body-medium">{translatedButtonLabelClearComparator}</a></p>
//           }
//         </div>
//       </section>
//
//       <section className="border-t border-cc-gray-05 pt-4">
//         <header className="flex flex-row items-center justify-between py-2 mb-4">
//           <h3><span className="font-semibold">{translatedLabelOther}</span><span className="ml-cc-1char text-cc-accent">({others.length})</span></h3>
//         </header>
//         <div className="max-w-full overflow-x-auto 3xs:overflow-visible pb-12">
//           <ul className="list-none flex flex-row space-x-6 3xs:space-x-0 3xs:grid 3xs:grid-cols-2 xs:grid-cols-3 md:grid-cols-4 3xs:gap-6">
//             {
//               others.map(
//                 (savedPartner, index) => {
//                   return (
//                     <li key={index} className="flex-shrink-0 w-cc-55 3xs:w-auto">
//                       <PartnerTile partner={savedPartner}/>
//                     </li>
//                   )
//                 }
//               )
//             }
//           </ul>
//           {
//             (others.length === 0) &&
//             <p>{translatedLabelNoMatchesFound}</p>
//           }
//         </div>
//       </section>


